<template>
  <div class="searchpage">
    <div class="regsearch">
      <div class="search">
        <img src="../../assets/images/searchsing.png" alt="" class="searchangle" @click="gobank">
        <img src="../../assets/images/search.png" alt="" class="searchpic">
        <form @submit.prevent action="#">
          <input type="search" placeholder="搜索医生" class="searchipt" value="" v-model="keyword" v-focus @keyup.enter="searchjump">
          <span class="searchbtn" @click="searchjump">搜索</span>
          <img src="../../assets/images/delx.png" alt="" class="delxicon" @click="delkeyword">
        </form>

      </div>
    </div>

    <div class="seachcon " v-show="!hasDate">
      <!--hasDate是否有数据显示-->

      <div class="reg-right">
        <ul>
          <li class="regdetiel" @click="detailfun(item.GUID)" v-for="item in doctors">
            <div class="picleft">
              <img :src="getDctImg(item.GUID)" />
            </div>
            <div class="conright">
              <div>
                <span class="regTitle">{{item.Name}}</span>
                <div class="frbox">
                  <span class="docter" v-bind:class="{ hidden: !item.Description }">{{item.Description}}</span>
                  <span class="source " :class="{sourcehas:item.BespeakNumber>0}">
                    {{item.BespeakNumber | bespeakNumberFilters}}
                  </span>
                </div>
              </div>
              <div class="regdetielcon">
                <p class="begoodat">擅长：{{item.Speciality}}</p>
                <p class="bref">简介：{{item.Synopsis}}</p>
              </div>
            </div>

          </li>
        </ul>
      </div>
    </div>

    <div class="noDate">
      <div v-show="hasDate">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt="" class="searchpic">
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { GetRegDctByDptID } from '@/services/getData.js';
  import weui from 'weui.js';
  export default {
    name: "register-search",
    data() {
      return {
        hasDate: false,
        doctors: {},
        keyword: this.$route.params.keyword
      };
    },
    created: function () {
      this.getRegDctByDptID();
    },
    methods: {
      getDctImg(id) {
        return config.configURL + "GetDctImg?id=" + id
      },
      detailfun(doctorID) {
        //跳转到挂号详情页
        this.$router.push({ name: 'RegisterDetail', params: { doctorID: doctorID } });
      },
      searchjump() {
        //查询
        this.getRegDctByDptID();
      },
      getRegDctByDptID() {
        var loading = weui.loading('loading', {
          className: 'custom-classname',
          content: '加载中'
        });
        if (this.keyword != "" && this.keyword != undefined) {
          GetRegDctByDptID("", this.keyword).then((response) => {
            loading.hide();
            this.doctors = response.data;

            if (response.data.length > 0) {
              
              this.hasDate = false;
            }
            else {
              this.hasDate = true;
            }
          })
        } else {
          this.doctors = [];
          loading.hide(function () { })
        }
      },
      delkeyword() {
        this.keyword = null;
      },
      gobank() {
        //返回上一级
        this.$router.go(-1);
      }
    },
    filters: {
      bespeakNumberFilters: function (value) {
        if (value > 0) {
          return "今日有号";
        }
        else {
          return "今日无号";
        }
      }
    },
    directives: {
      focus: {
        // 指令的定义
        inserted: function (el) {
          el.focus()
        }
      }
    }
  };
</script>
<style>
  .searchpage {
    width: 100%;
    height: auto;
  }

  .regsearch {
    width: 100%;
    height: 0.8rem;
    padding: 0.14rem 0.2rem;
    background: white;
    box-sizing: border-box;
    border-bottom: 0.01rem solid #dddddd;
    padding-left: 0.5rem;
  }

  .search .searchipt {
    width: 78%;
    height: 0.5rem;
    font-size: 0.22rem;
    font-family: "MicrosoftYaHei";
    color: #999999;
    background-color: #f2f2f2;
    border-radius: 0.1rem;
    padding-left: 0.51rem;
    box-sizing: border-box;
  }

  .searchpage .search {
    position: relative;
  }

    .searchpage .search .searchangle {
      width: 0.22rem;
      height: 0.22rem;
      position: absolute;
      left: -0.36rem;
      top: 0.172rem;
    }

    .searchpage .search .searchpic {
      width: 0.22rem;
      height: 0.22rem;
      position: absolute;
      left: 0.16rem;
      top: 0.14rem;
    }

    .searchpage .search .delxicon {
      width: 0.31rem;
      height: 0.3rem;
      position: absolute;
      right: 23%;
      /* top: 0.5rem; */
      bottom: 0.1rem;
    }

  .search .searchbtn {
    display: inline-block;
    width: 20%;
    height: 0.5rem;
    background: rgba(61,151,207,1);
    border-radius: 0.1rem;
    font-size: 0.24rem;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255,255,255,1);
    text-align: center;
    line-height: 0.5rem;
  }

  .searchicon {
    position: absolute;
    width: 0.22rem;
    height: 0.22rem;
    top: 0.3rem;
    left: 0.3rem;
  }

  .seachcon {
    width: 100%;
    height: 100%;
  }

  .noDate > div {
    font-size: 0.22rem;
    color: #999999;
    text-align: center;
    margin-top: 40%;
  }

    .noDate > div > img {
      margin: 0 auto;
      width: 3rem;
      height: 2.8rem;
    }

  .seachcon .reg-right {
    background-color: white;
    height: 100%;
    width: 100%;
  }

  .searchpage .regdetiel {
    /* padding:0.3rem 0; */
    margin-left: 0.39rem;
    border-bottom: 0.01rem dotted #dddddd;
    margin-right: 0.39rem;
  }

    .searchpage .regdetiel .picleft {
      height: 1.75rem;
      width: 1.25rem;
      float: left;
      margin-right: 0.16rem;
      box-sizing: border-box;
      padding-top: 0.2rem;
    }

      .searchpage .regdetiel .picleft > img {
        display: inline-block;
        height: 1.25rem;
      }

    .searchpage .regdetiel .conright {
      height: 1.75rem;
    }

    .searchpage .regdetiel .regTitle {
      font-size: 0.26rem;
      color: #333333;
      display: inline-block;
      margin-right: 0.19rem;
      line-height: 0.8rem;
      font-weight: 400;
    }

    .searchpage .regdetiel .docter {
      font-size: 0.18rem;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(255,255,255,1);
      background: rgba(61,151,209,1);
      border-radius: 0.1rem;
      line-height: 0.36rem;
      width: 0.85rem;
      height: 0.24rem;
      padding: 0 0.1rem;
    }

    .searchpage .regdetiel .source {
      font-size: 0.18rem;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: inline-block;
      padding: 0.01rem;
      box-sizing: border-box;
      border: 0.01rem solid rgba(210, 210, 210, 1);
      border-radius: 0.02rem;
      text-align: center;
    }

  .regdetiel .sourcehas {
    color: #3D97D1 !important;
    border-color: #3D97D1 !important;
  }

  .regdetiel .regdetielcon {
    font-size: 0.22rem;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(102,102,102,1);
    line-height: 0.36rem;
  }

  .begoodat {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .regdetiel .regdetielcon .bref {
    overflow: hidden;
    text-overflow: clip;
    white-space: nowrap;
    margin-bottom: 0.3rem;
  }

  .frbox {
    float: right;
    margin-top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register-search.vue